import React, { FC } from 'react'

import { Text } from '@interco/inter-ui/components/Text'

import { Circle, SpinnerContainer, Svg } from '../styles'
import { TLoaderProps } from '../types'

export const Loader: FC<TLoaderProps> = ({ message, pxToSubtractFrom100vh, size = 30 }) => (
  <SpinnerContainer $pxToSubtractFrom100vh={pxToSubtractFrom100vh}>
    <Loading width={size} height={size} color="var(--primary500)" strokeWidth={1} />
    {message && (
      <Text variant="body-3" color="typography">
        {message}
      </Text>
    )}
  </SpinnerContainer>
)

export const Loading = React.memo(
  ({
    width = 24,
    height = 24,
    color = 'var(--highlight-color)',
    dataTestId = 'loading-icon',
    ...attrs
  }: DefaultSVGProps) => (
    <Svg
      viewBox="0 0 24 24"
      fill="none"
      width={width}
      height={height}
      data-testid={dataTestId}
      {...attrs}
    >
      <Circle cx="12" cy="12" r="8" stroke={color} strokeWidth="1" />
      <path
        d="M12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20C10.5429 20 9.17669 19.6104 8 18.9297"
        stroke={color}
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  ),
)
